import { Identifiable, Resource } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function getUnReadNotificationsNbr(httpClient: HttpClient) {
  return (resource: Identifiable<Resource>) =>
    httpClient
      .sendHttpRequest<{ page: { totalElements: number } }>({
        endpoint: `/resourceNotifications/search/rsql?query=isRead==false and resource.uuid==${resource.uuid}`,
        method: HttpMethods.GET,
      })
      .then(({ page }) => page.totalElements);
}

export { getUnReadNotificationsNbr };
